var _mask, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 48,
    viewBox: "0 0 97 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_120_5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000488281L87 -0.000488281C92.5228 -0.000488281 97 4.47666 97 9.99951L97 47.9995L0 47.9995L0 -0.000488281Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000488281L87 -0.000488281C92.5228 -0.000488281 97 4.47666 97 9.99951L97 47.9995L0 47.9995L0 -0.000488281Z",
    fill: "#F7EC1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-6 -6.00049L87 -6.00049C94.732 -6.00049 101 0.267525 101 7.99951L93 9.99951C93 7.79037 90.3137 5.99951 87 5.99951L6 5.99951L-6 -6.00049ZM101 51.9995L-6 51.9995L6 43.9995L93 43.9995L101 51.9995ZM-6 51.9995L-6 -6.00049L6 5.99951L6 43.9995L-6 51.9995ZM87 -6.00049C94.732 -6.00049 101 0.267525 101 7.99951L101 51.9995L93 43.9995L93 9.99951C93 7.79037 90.3137 5.99951 87 5.99951V-6.00049Z",
    fill: "black",
    mask: "url(#path-1-inside-1_120_5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 32.0294H34.5V33.0294V42.0937L10.7314 25.6728L34.5 8.45893V17.3067V18.3067H35.5L87 18.3067V32.0294L35.5 32.0294Z",
    fill: "#C01414",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.47919d5af84bc93b8459858bc7673007.svg";
export { ForwardRef as ReactComponent };